import React from 'react'
import Layout from '../components/Layout/Layout'
import ProfileComponent from '../components/ProfileComponent'

const Profile = () => {
  return (
    <>
     <Layout>
        <ProfileComponent />
     </Layout>
    </>
  )
}

export default Profile